import { Injectable, ChangeDetectorRef, ApplicationRef } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class LoaderService {
	public loader;
	constructor() { }

	public setValue(value: boolean): void {
		this.loader = value;
	}

	public getValue(): boolean {
		return this.loader;
	}
}
